<template>
  <div class="buttonSelect" :style="{ top: top + 'px' }" :class="{ hidden: !visible }">
    <template v-if="list.length == 0">
      <div class="empty">无数据</div>
    </template>
    <template v-else>
      <div v-for="(condition, conditionIndex) in list" :key="conditionIndex" class="conditionBox">
        <div class="conditionTitle" @click.stop="toggleActiveCondition(conditionIndex)">
          <!-- <i :class="condition.icon"></i> -->
          <div class="title ellipsis" :class="{ active: activeCondition == conditionIndex }">
            {{ condition.title }}
          </div>
          <!-- <div class="subTitle ellipsis">{{ condition.subTitle }}</div> -->
          <i
            class="el-icon-arrow-down rotate--initial"
            :class="{ rotate: activeCondition == conditionIndex }"
          ></i>
        </div>
        <ul v-if="activeCondition == conditionIndex" class="conditionFieldBox">
          <li
            v-for="(item, index) in condition.options"
            :key="index"
            class="fieldRow ellipsis"
            @click.stop="selectItem(item, condition)"
          >
            <!-- <span class="field">[{{ item.type }}]</span> -->
            <span>{{ item.label }}</span>
          </li>
        </ul>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "ButtonSelect",
  props: {
    top: String,
    visible: Boolean,
    /*
      list: [
        {
          id: "",
          title: "",
          options: [
            {
              label: "",
              type: "",
              value: ""
            },
            ...
          ]
        },
        ...
      ]
    */
    list: Array,
    defaultExpend: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      activeCondition: -1
    }
  },
  watch: {
    visible(val) {
      if (val) window.addEventListener("click", this.clickListener, true)
    }
  },
  created() {
    window.addEventListener("click", this.clickListener, true)
    this.activeCondition = this.defaultExpend
  },
  methods: {
    toggleActiveCondition(conditionIndex) {
      if (this.activeCondition == conditionIndex) {
        // 收起已展开的列表
        this.activeCondition = -1
      } else {
        // 展开列表
        this.activeCondition = conditionIndex
      }
    },
    clickListener(e) {
      if (
        e.target.className.indexOf("fieldRow") != -1 ||
        e.target.parentNode.className.indexOf("fieldRow") != -1 ||
        e.target.className.indexOf("conditionTitle") != -1 ||
        e.target.parentNode.className.indexOf("conditionTitle") != -1 ||
        e.target.className.indexOf("buttonSelectTrigger") != -1 ||
        e.target.parentNode.className.indexOf("buttonSelectTrigger") != -1
      ) {
        return false
      } else {
        // this.activeCondition = -1
        window.removeEventListener("click", this.clickListener, true)
        this.$emit("update:visible", false)
      }
    },
    selectItem(item, itemParent) {
      this.$emit("handle-select", { item, itemParent })
      this.$emit("update:visible", false)
    }
  }
}
</script>

<style lang="scss">
.buttonSelect {
  position: absolute;
  left: 0;
  width: 100%;
  padding: 6px 0;
  max-height: 400px;
  overflow-x: hidden;
  overflow-y: auto;
  font-size: 13px;
  background-color: #fff;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.26);
  z-index: 100;
  border-radius: 3px;
  margin-bottom: 24px;
  color: #2c3e50;
  .empty {
    color: #9e9e9e;
    line-height: 24px;
    text-align: center;
  }
  .conditionTitle {
    display: flex;
    padding: 0 16px;
    align-items: center;
    height: 36px;
    cursor: pointer;
    .active {
      color: #1e88e5;
    }
    &:hover {
      .title {
        color: #1e88e5;
      }
    }
    .title {
      margin-left: 10px;
      flex: 1 1;
    }
    .subTitle {
      max-width: 150px;
      margin-left: 15px;
      margin-right: 10px;
    }
    .rotate--initial {
      transform: rotate(0);
      -webkit-transition: -webkit-transform 0.3s ease;
      transition: transform 0.3s ease;
    }
    .rotate {
      transform: rotate(180deg);
      -webkit-transition: -webkit-transform 0.3s ease;
      transition: transform 0.3s ease;
    }
  }
  .conditionFieldBox {
    line-height: 1.5;
    margin: 0;
    padding: 0;
    list-style-type: none;
    height: 100%;
    overflow: hidden;
    background-color: #f5f5f5;
    .fieldRow {
      list-style: none;
      display: flex;
      align-items: center;
      height: 36px;
      padding: 0 16px 0 39px;
      cursor: pointer;
      &:hover {
        background-color: #1e88e5;
        color: #fff;
        .field {
          color: #fff;
        }
      }
      .field {
        margin-right: 5px;
        color: #8f8f8f;
      }
    }
  }
}
</style>
